import PropTypes from "prop-types";
import { getDayOfTheWeek } from "../../../../core/helpers/date-helper";

const ESTILOS_TH = {
    padding: "5px 10px",
};

const CabeceraTablaCuadrosTurnos = ({ fechasCuadroTurnos, area }) => {
    const meses = [];
    const celdasDias = [];

    for (const mes in fechasCuadroTurnos) {
        let numeroDeCeldas = 0;

        fechasCuadroTurnos[mes].dias.forEach((fecha, index) => {
            const textoDiaDeLaSemana = getDayOfTheWeek(fecha.fecha);
            celdasDias.push(
                <th
                    key={`diasSemana-${mes}-${index}`}
                    style={{
                        fontSize: "8px",
                        ...ESTILOS_TH,
                    }}
                >
                    {fecha.dia} <br />
                    {textoDiaDeLaSemana}
                </th>
            );
            numeroDeCeldas++;

            if (
                textoDiaDeLaSemana === "DOM" ||
                fechasCuadroTurnos[mes].dias.length - 1 === index
            ) {
                celdasDias.push(
                    <th
                        key={`diasSemana-${mes}-${index}-total-horas-semana`}
                        style={ESTILOS_TH}
                        className="celda-acumulado-horas"
                    >
                        <div title="Total Horas Semana">
                            <i className="fas fa-info-circle"></i>
                        </div>
                    </th>
                );

                numeroDeCeldas++;
            }

            if (fechasCuadroTurnos[mes].dias.length - 1 === index) {
                celdasDias.push(
                    <th
                        key={`diasSemana-${mes}-${index}-total-horas-acumuladas`}
                        style={ESTILOS_TH}
                        className="celda-acumulado-horas"
                    >
                        <div title="Total Horas Acumuladas">
                            <i className="fas fa-info-circle"></i>
                        </div>
                    </th>
                );

                numeroDeCeldas++;
            }
        });

        meses.push(
            <th
                key={`mes-${mes}`}
                className="bg-primary"
                colSpan={numeroDeCeldas}
                style={ESTILOS_TH}
            >
                {mes}
            </th>
        );
    }

    return (
        <thead
            style={{ position: "sticky", top: 0, zIndex: 1 }}
            className="bg-white"
        >
            <tr className="text-center bg-primary">
                <th colSpan={2} style={ESTILOS_TH}>
                    {area}
                </th>
                {meses}
            </tr>
            <tr className="text-center bg-white">
                <th style={{ width: "25px"}}></th>
                <th style={{ width: "120px", ...ESTILOS_TH }}>Colaborador</th>
                {celdasDias}
            </tr>
        </thead>
    );
};

CabeceraTablaCuadrosTurnos.propTypes = {
    fechasCuadroTurnos: PropTypes.object,
    area: PropTypes.string,
};

export default CabeceraTablaCuadrosTurnos;
